import React from "react";
import className from "../../core/utils/class-names";
import "./BaseLayout.scss";
const BaseLayout = ({ nav, topNav, sideNav, topNavBar, orientation, children, isSideNaveHidden = false, landingChrome = false, }) => {
    const mainContentClasses = className({
        "main-content": true,
        loaded: true,
        fulfilled: true,
        "main-content--landing": landingChrome,
    });
    const mainContentWrapClasses = className({
        "main-content-wrap": true,
        "main-content-fit-window": isSideNaveHidden,
        "main-content-wrap--landing": landingChrome,
    });
    const appContainerClasses = className({
        "app-container": true,
        "custom-padding": isSideNaveHidden,
        "landing-chrome": landingChrome,
    });
    return (React.createElement("div", { className: `layout ${orientation}` },
        React.createElement("div", { className: appContainerClasses },
            nav,
            topNav,
            React.createElement("main", { className: mainContentClasses },
                React.createElement("div", { className: mainContentWrapClasses }, children)),
            !isSideNaveHidden && sideNav)));
};
export default BaseLayout;
